<form>
  <div class="row">
  <div class="col-md-12 col-xl-12">
    <div class="table-responsive our-table">
      <table class="table table-striped text-nowrap mb-0">
        <thead class="border-top">
          <tr>
            <th scope="col" class="text-capitalize">{{ 'common.client' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.depositTotal' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.splitDeposit' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.withdrawalTotal' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.splitWithdrawal' | translate}}</th>
            <th scope="col" class="text-capitalize">{{ 'common.commissionTotal' | translate}}</th>
          </tr>
        </thead>
        <tbody>
        <tr class="border-bottom" *ngFor="let transaction of transactions">
          <td><span>{{transaction.description }}</span></td>
          <td><span>{{transaction.valueCashIn | formatCurrency }}</span></td>
          <td><span>{{ transaction.taxaCashIn/100 | percent:'1.2-2' }} + {{transaction.taxaQtdeCashIn| formatCurrency}}</span></td>
            <td><span>{{ transaction.valueCashOut | formatCurrency }}</span></td>
            <td><span>{{ transaction.taxaCashOut/100 | percent:'1.2-2' }} + {{transaction.taxaQtdeCashOut | formatCurrency}}</span></td>
            <td><span>{{ transaction.commission | formatCurrency }}</span></td>
          </tr>
          <tr *ngIf="transactions.length == 0">
            <td colspan="12">{{ 'common.noData' | translate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</form>
